import React from 'react';
import './chip.css';
import { Link } from 'react-router-dom';

const CategoryChip = (props) => {
    return ( <>
    <Link className={props.class}>
        {props.title}
    </Link>
    </> );
}
 
export default CategoryChip;